import { Field, Textarea } from '../../components/ui';
import { MAX_TEXT_CHARS } from './format';
import styles from './placement.module.css';

interface Props {
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
}

export function ContextField({ value, onChange, disabled }: Props) {
  const overLimit = value.length > MAX_TEXT_CHARS;

  return (
    <Field
      layout="stacked"
      label="Сценарий целиком"
      hint="необязательно: чтобы нейросеть поняла, о чём ролик"
    >
      {(id) => (
        <>
          <Textarea
            id={id}
            rows={6}
            value={value}
            disabled={disabled}
            spellCheck={false}
            placeholder="Вставьте весь сценарий ролика. Вставки в него не ставятся."
            onChange={(event) => onChange(event.target.value)}
          />
          {overLimit && (
            <span className={`${styles.hint} ${styles.overLimit}`}>
              «Сценарий целиком» длиннее лимита: {value.length.toLocaleString('ru-RU')} /{' '}
              {MAX_TEXT_CHARS.toLocaleString('ru-RU')} знаков
            </span>
          )}
        </>
      )}
    </Field>
  );
}
